/**
 * useSessionSiteId
 *
 * Derives the current session site ID from the active area.
 *
 * Each area carries a `siteFilterId` reference — when the active area
 * changes the site ID updates automatically. Falls back to the Redux
 * session value when no area is resolved.
 */
import { useAppSelector } from '@/store/hooks';
import { areasItemsSelector } from '@/store/selectors/areas';
import { collectionsSelector } from '@/store/selectors/collections';
import { selectSiteId } from '@/store/slices/sessionSlice';
import { useSessionCollectionName } from './useSessionCollectionName';
import { useSessionAreaName } from './useSessionAreaName';
export const useSessionSiteId = () => {
    var _a;
    const collectionName = useSessionCollectionName();
    const areaName = useSessionAreaName();
    const areas = useAppSelector(areasItemsSelector);
    const collections = useAppSelector(collectionsSelector);
    const collection = collections.find(({ collection: name }) => name === collectionName);
    const area = collection
        ? areas.find((a) => a.collectionId === collection.id && a.name === areaName)
        : undefined;
    const siteIdFromArea = (_a = area === null || area === void 0 ? void 0 : area.siteFilterId) !== null && _a !== void 0 ? _a : undefined;
    // Fallback: read from Redux session (for backward compat during migration)
    const siteIdFromRedux = useAppSelector(selectSiteId);
    return siteIdFromArea !== null && siteIdFromArea !== void 0 ? siteIdFromArea : siteIdFromRedux;
};
